export const START_TIMELINE_GAME_COMPLETED = "timeline/startCompleted";
export const VALIDATE_TIMELINE_COMPLETED = "timeline/validateCompleted";
export const REVEAL_TIMELINE_COMPLETED = "timeline/revealCompleted";
export const CLEAR_TIMELINE_VALIDATION = "timeline/clearValidation";
